import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

export const CtaBand = () => (
  <section className="relative overflow-hidden bg-night py-20 text-white sm:py-28 grain" data-testid="cta-band">
    <div className="absolute inset-0 grid-lines" aria-hidden="true" />
    <div className="container-x relative grid gap-10 lg:grid-cols-12 lg:items-end">
      <Reveal className="lg:col-span-7">
        <p className="eyebrow">Parlons de votre projet</p>
        <h2 className="h-section mt-5">
          Un projet d'approvisionnement <span className="text-gold">ou de négoce ?</span> Parlons-en.
        </h2>
        <p className="lede mt-5 max-w-xl !text-white/70">
          Décrivez votre besoin : nous revenons vers vous sous {site.responseDelay} et vous adressons une proposition chiffrée sous {site.quoteDelay}.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="flex flex-col gap-4 lg:col-span-5 lg:items-end">
        <Link to="/contact#devis" className="btn-gold !px-8 !py-4 text-base" data-testid="cta-band-devis-btn">
          Demander un devis <ArrowUpRight className="h-5 w-5" />
        </Link>
        <div className="flex flex-col gap-2 text-sm text-white/75 lg:items-end">
          <a href={site.phoneHref} className="inline-flex items-center gap-2 hover:text-gold"><Phone className="h-4 w-4 text-gold" />{site.phone}</a>
          <a href={site.emailHref} className="inline-flex items-center gap-2 hover:text-gold"><Mail className="h-4 w-4 text-gold" />{site.email}</a>
        </div>
      </Reveal>
    </div>
  </section>
);
